/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var environment = __webpack_require__(2);
	
	/* Add the contextual CSP policy to the meta tag with an iffe */
	(function () {
	  var cspMetaTag = document.createElement('meta');
	  cspMetaTag.setAttribute("http-equiv", "Content-Security-Policy");
	  cspMetaTag.setAttribute("content", environment.csp_policy);
	
	  var head = document.getElementsByTagName('head')[0];
	  head.insertBefore(cspMetaTag, head.firstChild);
	})();

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/* This require needs to be relative to the root folder since this file gets copied over to environment.js on deploy */
	const config = __webpack_require__(3);
	
	module.exports = config.endpoints.production;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _contentSecurityPolicy = __webpack_require__(4);
	
	Object.defineProperty(exports, 'getDirectives', {
	  enumerable: true,
	  get: function get() {
	    return _contentSecurityPolicy.getDirectives;
	  }
	});
	Object.defineProperty(exports, 'makePolicy', {
	  enumerable: true,
	  get: function get() {
	    return _contentSecurityPolicy.makePolicy;
	  }
	});
	
	var _endpoints = __webpack_require__(5);
	
	Object.defineProperty(exports, 'endpoints', {
	  enumerable: true,
	  get: function get() {
	    return _endpoints.endpoints;
	  }
	});
	
	var _devConfig = __webpack_require__(44);
	
	Object.defineProperty(exports, 'setDevEnv', {
	  enumerable: true,
	  get: function get() {
	    return _devConfig.setDevEnv;
	  }
	});

/***/ },
/* 4 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-param-reassign, no-restricted-syntax */
	var defaultDirectives = {
	  'default-src': ["'self'"],
	  'base-uri': ["'self'"],
	  'font-src': ["'self'", 'https://*.twimg.com', 'https://fonts.gxstatic.com', 'https://*.cloudfront.net', 'https://fonts.googleapis.com', "https://s3.amazonaws.com/icomoon.io/33289/AdParlor/", 'http://*.twimg.com', 'http://fonts.gstatic.com', 'http://*.cloudfront.net', 'http://fonts.googleapis.com', 'https://at.alicdn.com', 'data:'],
	  'style-src': ["'self'", "'unsafe-inline'", 'https://*.twimg.com', 'https://*.cloudfront.net/', 'https://fonts.googleapis.com/', 'https://storage.googleapis.com', "https://s3.amazonaws.com/icomoon.io/33289/AdParlor/", 'https://app.pendo.io', 'https://cdn.pendo.io', 'https://pendo-static-4524865072136192.storage.googleapis.com', 'http://*.twimg.com', 'http://*.cloudfront.net/', 'http://fonts.googleapis.com/', 'http://storage.googleapis.com', 'http://app.pendo.io', 'http://cdn.pendo.io', 'http://pendo-static-4524865072136192.storage.googleapis.com', 'http://cdnjs.cloudflare.com', 'https://cdnjs.cloudflare.com'],
	  'script-src': ["'self'", 'https://*.pendo.io', 'https://bam.nr-data.net', '', 'https://*.filepicker.io', 'https://*.facebook.net', 'https://*.facebook.com', 'https://*.facebook.net', 'https://*.facebook.com', 'https://*.google-analytics.com', 'https://js.logentries.com/', 'https://ajax.googleapis.com', 'https://js-agent.newrelic.com/nr-632.min.js', 'https://pendo-io-static.storage.googleapis.com', 'https://cdn.pendo.io', 'https://pendo-static-4524865072136192.storage.googleapis.com', 'http://*.pendo.io', 'http://bam.nr-data.net', '', 'http://*.filepicker.io', 'http://*.facebook.net', 'http://*.facebook.com', 'http://*.facebook.net', 'http://*.facebook.com', 'http://*.google-analytics.com', 'http://js.logentries.com/', 'http://ajax.googleapis.com', 'http://js-agent.newrelic.com/nr-632.min.js', 'http://pendo-io-static.storage.googleapis.com', 'http://cdn.pendo.io', 'http://pendo-static-4524865072136192.storage.googleapis.com', 'https://adparlor.atlassian.net', 'http://cdnjs.cloudflare.com', 'https://cdnjs.cloudflare.com'],
	  'child-src': ["'self'", 'https://*.facebook.com', 'https://*.filepicker.io', 'https://*.yimg.com', 'https://*.zenfs.com', 'https://*.youtube.com', 'https://*.vimeo.com', 'http://*.facebook.com', 'http://*.filepicker.io', 'http://*.yimg.com', 'http://*.zenfs.com', 'http://*.youtube.com', 'http://*.vimeo.com', 'https://adparlor.atlassian.net', 'http://adparlor.atlassian.net'],
	  'frame-src': ["'self'", 'https://*.facebook.com', 'https://*.filepicker.io', 'https://*.yimg.com', 'https://*.zenfs.com', 'https://*.youtube.com', 'https://*.vimeo.com', 'https://adparlor.atlassian.net', 'http://*.facebook.com', 'http://*.filepicker.io', 'http://*.yimg.com', 'http://*.zenfs.com', 'http://*.youtube.com', 'http://*.vimeo.com', 'http://adparlor.atlassian.net'],
	  // "frame-ancestors": ["https://app.pendo.io", "http://app.pendo.io"], - Cannot deliver through meta tag. Added to nginx config.
	  'media-src': ["'self'", 'https://*.amazonaws.com', 'https://*.filepicker.io', 'http://*.amazonaws.com', 'http://*.filepicker.io'],
	  'connect-src': ["'self'", "https://*.facebook.com", 'https://*.adparlor.com', 'https://js.logentries.com', 'https://app.pendo.io', 'http://*.adparlor.com', 'http://js.logentries.com', 'http://app.pendo.io', 'https://ap-prod-pigeonhole-elb-1754679576.us-west-2.elb.amazonaws.com', 'https://*.adparlordev.com', 'https://api.airbrake.io', 'ws:'],
	  'img-src': ["'self'", 'https://files.slack.com', 'https://*.pendo.io', 'https://adparlor.com', 'https://*.adparlor.com', 'https://*.facebook.com', 'https://*.fbcdn.net', 'https://*.akamaihd.net', 'https://*.twimg.com', 'https://*.mzstatic.com', 'https://*.pinimg.com', 'https://*.ytimg.com', 'https://cdn.pendo.io', 'https://app.pendo.io', 'https://pendo-static-4524865072136192.storage.googleapis.com', 'https://*.amazonaws.com', 'https://*.google-analytics.com', 'https://*.cloudfront.net', 'https://storage.googleapis.com', 'https://twemoji.maxcdn.com', 'https://*.ggpht.com', 'http://*.pendo.io', 'http://adparlor.com', 'http://*.adparlor.com', 'http://*.facebook.com', 'http://*.fbcdn.net', 'http://*.akamaihd.net', 'http://*.twimg.com', 'http://*.mzstatic.com', 'http://*.pinimg.com', 'http://*.ytimg.com', 'http://cdn.pendo.io', 'http://app.pendo.io', 'http://pendo-static-4524865072136192.storage.googleapis.com', 'http://*.amazonaws.com', 'http://*.google-analytics.com', 'http://*.cloudfront.net', 'http://storage.googleapis.com', 'http://twemoji.maxcdn.com', 'http://*.ggpht.com', 'data:']
	};
	
	// Get a new cloned instance of the directives
	var getDirectives = function getDirectives() {
	  var directives = {};
	  for (var directive in defaultDirectives) {
	    if (Object.prototype.hasOwnProperty.call(defaultDirectives, directive)) {
	      (function () {
	        var copiedDirectiveArray = [];
	        defaultDirectives[directive].forEach(function (rule) {
	          copiedDirectiveArray.push(rule);
	        });
	        directives[directive] = copiedDirectiveArray;
	      })();
	    }
	  }
	  return directives;
	};
	
	/* Function that generates the policy string that the meta tag's content attribute requires in index files */
	var makePolicy = function makePolicy(directives) {
	  if (!directives) directives = getDirectives();
	  var policy = '';
	  for (var key in directives) {
	    if (Object.prototype.hasOwnProperty.call(directives, key)) {
	      var directivePolicy = directives[key].join(' ');
	      policy += key + ' ' + directivePolicy + ';\n\n';
	    }
	  }
	  return policy;
	};
	
	module.exports = { getDirectives: getDirectives, makePolicy: makePolicy };

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.endpoints = undefined;
	
	var _contentSecurityPolicy = __webpack_require__(4);
	
	var _general = __webpack_require__(6);
	
	/* Adding to directives arrays in each endpoint file's global scope, or in each csp_policy function, prior to
	 * using makePolicy with the directives, will allow individual endpoints to specify which policy to use.
	 * For example:
	 *      directives["script-src"].push("http://someDomain.com")
	 * This will add someDomain.com to our white list of domains, which is allowed to execute scripts in the app.
	 */
	
	var addLocalWhitelists = function addLocalWhitelists(directives) {
	  /* Unsafe-eval for local development is necessary for best experience with Webpack builds */
	  directives["style-src"].push("blob:");
	  directives["script-src"].push("'unsafe-eval'");
	  directives["script-src"].push("'unsafe-inline'");
	  directives["connect-src"].push("http://localhost:*");
	};
	
	var endpoints = exports.endpoints = {
	  development: {
	    mobile_api_url: "/dev/api/system",
	    system_api_url: "/dev/api/system",
	    handshake_api_url: "/dev/api/handshake",
	    assets_url: "/dev/api/assets",
	    yahoo_api_url: "/dev/api/yahoo",
	    pinterest_api_url: "/dev/api/pinterest",
	    trivu_api_url: "/dev/api/trivu",
	    trivu_v2_api_url: "/dev/api/tubetop",
	    facebook_api_url: "/dev/api/facebook",
	    facebook_app_id: "213476522140811",
	    facebook_v2_api_url: "/dev/api/facebook_v2",
	    facebook_v3_api_url: "/dev/api/facebook_v3",
	    facebook_self_serve_app_id: "243863395812506",
	    web_app_url: "http://adparlor.local/adparlor_1812_frontend/",
	    twitter_api_url: "/dev/api/twitter",
	    banana_api_url: "/dev/api/banana",
	    ruler_api_url: "/dev/api/ruler",
	    graffiti_api_url: "/dev/api/graffiti",
	    snapchat_api_url: "/dev/api/casper",
	    enable_facebook: "true",
	    enable_twitter: "true",
	    enable_yahoo: "false",
	    enable_pinterest: "false",
	    enable_snapchat: "false",
	    logentries_key: "90af9377-f436-485b-89a6-c6cb98ce5541",
	    filepicker_key: "A0p6RRB0FS6uKOEFJ2Dr2z",
	    S3_container: "sor-filepicker",
	    csp_policy: function () {
	      var directives = (0, _contentSecurityPolicy.getDirectives)();
	      addLocalWhitelists(directives);
	      return (0, _contentSecurityPolicy.makePolicy)(directives);
	    }()
	  },
	
	  sandbox: {
	    system_api_url: "https://system.api.sandbox.adparlordev.com/api",
	    handshake_api_url: "https://handshake.api.sandbox.adparlordev.com/v1",
	    assets_url: "https://system.api.sandbox.adparlordev.com",
	    facebook_api_url: "https://facebook-v1.api.sandbox.adparlordev.com",
	    facebook_v2_api_url: "https://facebook.api.sandbox.adparlordev.com/v2",
	    facebook_v3_api_url: "https://facebook.api.sandbox.adparlordev.com/v3",
	    facebook_app_id: "213476522140811",
	    facebook_self_serve_app_id: "243863395812506",
	    web_app_url: "https://app.sandbox.adparlordev.com",
	    twitter_api_url: "https://twitter.api.sandbox.adparlordev.com/v6",
	    banana_api_url: "https://banana.api.sandbox.adparlordev.com",
	    ruler_api_url: "https://ruler.api.sandbox.adparlordev.com/v1",
	    yahoo_api_url: "https://yahoo.api.sandbox.adparlordev.com/v1",
	    pinterest_api_url: "https://pinterest.api.sandbox.adparlordev.com/v1",
	    trivu_api_url: "https://trivu.api.sandbox.adparlordev.com/v2",
	    vc_api_url: "https://tubetop.api.sandbox.adparlordev.com/v2",
	    dbm_api_url: "https://dbm.api.sandbox.adparlordev.com/v1",
	    graffiti_api_url: "https://graffiti-v2.api.sandbox.adparlordev.com/v1",
	    snapchat_api_url: "https://snapchat.api.sandbox.adparlordev.com/v1",
	    ripple_api_url: "https://ripple.api.sandbox.adparlordev.com/v1",
	    crossroads_api_url: "https://crossroads.api.sandbox.adparlordev.com/v1",
	    crossbow_api_url: "https://crossbow.api.sandbox.adparlordev.com/v1",
	    hook_api_url: "https://hook.api.sandbox.adparlordev.com",
	    cupid_api_url: "https://cupid.api.sandbox.adparlordev.com/v1",
	    convention_api_url: "https://convention.api.sandbox.adparlordev.com",
	    thumbsup_api_url: "https://thumbsup.api.sandbox.adparlordev.com",
	    palette_api_url: "https://palette.api.sandbox.adparlordev.com/v1",
	    picasso_api_url: "https://picasso.api.sandbox.adparlordev.com/v1",
	    enable_facebook: "true",
	    enable_twitter: "true",
	    enable_yahoo: "false",
	    enable_pinterest: "false",
	    enable_snapchat: "false",
	    enable_dbm: "false",
	    enable_youtube: "false",
	    enable_trivu: "false",
	    logentries_key: "d6643746-e5cf-4637-a9cf-30fa1bf0f9f7",
	    filepicker_key: "A0p6RRB0FS6uKOEFJ2Dr2z",
	    S3_container: "ap-dev-filepicker",
	    csp_policy: function () {
	      var directives = (0, _contentSecurityPolicy.getDirectives)();
	      directives["connect-src"].push("https://*.api.sandbox.adparlordev.com");
	      directives["img-src"].push("https://*.api.sandbox.adparlordev.com");
	      if (!(0, _general.isProdEnv)()) addLocalWhitelists(directives);
	      return (0, _contentSecurityPolicy.makePolicy)(directives);
	    }()
	  },
	
	  // ----------------------- DEPRECATED -----------------------
	  quality: {
	    mobile_api_url: "/quality/api/system",
	    system_api_url: "/quality/api/system",
	    assets_url: "/quality/api/assets",
	    yahoo_api_url: "/quality/api/yahoo",
	    pinterest_api_url: "/quality/api/pinterest",
	    trivu_api_url: "/quality/api/trivu",
	    trivu_v2_api_url: "/quality/api/tubetop",
	    facebook_api_url: "/quality/api/facebook",
	    facebook_app_id: "213476522140811",
	    facebook_v2_api_url: "/quality/api/facebook_v2",
	    facebook_v3_api_url: "/quality/api/facebook_v3",
	    facebook_self_serve_app_id: "243863395812506",
	    web_app_url: "http://localhost/adparlor_1812_frontend/index.html",
	    twitter_api_url: "/quality/api/twitter",
	    banana_api_url: "/quality/api/banana",
	    ruler_api_url: "http://localhost:9777/v1",
	    graffiti_api_url: "/quality/api/graffiti",
	    snapchat_api_url: "/quality/api/casper",
	    enable_facebook: "true",
	    enable_twitter: "true",
	    enable_yahoo: "true",
	    enable_pinterest: "true",
	    enable_snapchat: "true",
	    logentries_key: "90af9377-f436-485b-89a6-c6cb98ce5541",
	    filepicker_key: "A0p6RRB0FS6uKOEFJ2Dr2z",
	    S3_container: "sor-filepicker",
	    csp_policy: function () {
	      var directives = (0, _contentSecurityPolicy.getDirectives)();
	      if (!(0, _general.isProdEnv)()) addLocalWhitelists(directives);
	      return (0, _contentSecurityPolicy.makePolicy)(directives);
	    }()
	  },
	
	  production: {
	    system_api_url: "https://system-api.adparlor.com/api",
	    handshake_api_url: "https://handshake.api.adparlor.com/v1",
	    assets_url: "https://system-api.adparlor.com",
	    facebook_api_url: "https://facebook-v1-api.adparlor.com",
	    facebook_v2_api_url: "https://facebook-api.adparlor.com/v2",
	    facebook_v3_api_url: "https://facebook-api.adparlor.com/v3",
	    facebook_app_id: "213476522140811",
	    facebook_self_serve_app_id: "243863395812506",
	    web_app_url: "https://app.adparlor.com",
	    twitter_api_url: "https://twitter-api.adparlor.com/v6",
	    banana_api_url: "https://banana-api.adparlor.com",
	    ruler_api_url: "https://ruler-api.adparlor.com/v1",
	    yahoo_api_url: "DEPRECATED",
	    pinterest_api_url: "https://pinterest-api.adparlor.com/v1",
	    trivu_api_url: "https://tubetop-api.adparlor.com/v2",
	    vc_api_url: "https://tubetop-api.adparlor.com/v2",
	    graffiti_api_url: "https://graffiti-v2.api.adparlor.com/v1",
	    snapchat_api_url: "https://snapchat-api.adparlor.com/v1",
	    ripple_api_url: "https://ripple-api.adparlor.com/v1",
	    crossroads_api_url: "https://crossroads.api.adparlor.com/v1",
	    crossbow_api_url: "https://crossbow.api.adparlor.com/v1",
	    hook_api_url: "https://hook-api.adparlor.com",
	    dbm_api_url: "https://decibel-api.adparlor.com/v1",
	    cupid_api_url: "https://cupid.api.adparlor.com/v1",
	    convention_api_url: "https://convention.api.adparlor.com",
	    thumbsup_api_url: "https://thumbsup.api.adparlor.com",
	    palette_api_url: "https://palette.api.adparlor.com/v1",
	    picasso_api_url: "https://picasso.api.adparlor.com/v1",
	    enable_facebook: "true",
	    enable_twitter: "true",
	    enable_yahoo: "false",
	    enable_pinterest: "false",
	    enable_snapchat: "false",
	    enable_dbm: "false",
	    enable_youtube: "false",
	    enable_trivu: "false",
	    logentries_key: "d6643746-e5cf-4637-a9cf-30fa1bf0f9f7",
	    filepicker_key: "An5rln3AcQ5iIHRoWrR73z",
	    S3_container: "ap-prod-filepicker",
	    csp_policy: function () {
	      var directives = (0, _contentSecurityPolicy.getDirectives)();
	      if (!(0, _general.isProdEnv)()) addLocalWhitelists(directives);
	      return (0, _contentSecurityPolicy.makePolicy)(directives);
	    }()
	  }
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(7);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.buildActionsCollection = buildActionsCollection;
	exports.getEndpoints = getEndpoints;
	exports.changeWebAppUrl = changeWebAppUrl;
	exports.isProdEnv = isProdEnv;
	
	var _config = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * buildActionsCollection() returns a function [action, props] which checks action against a collection of actions
	 * and dispatches the action if found.
	 * @param {Object} collection - plain object with actions
	 * @param {function} dispatch - dispatch function for the store
	 */
	function buildActionsCollection(collection, dispatch) {
	  return function (action) {
	    if (typeof collection[action] !== 'undefined') {
	      for (var _len = arguments.length, props = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        props[_key - 1] = arguments[_key];
	      }
	
	      return dispatch(collection[action].apply(collection, props));
	    }
	    throw Error('Invalid action creator');
	  };
	}
	
	function getEndpoints(env) {
	  switch (env) {
	    case 'development':
	      return _config.endpoints.development;
	    case 'sandbox':
	      return _config.endpoints.sandbox;
	    case 'quality':
	      return _config.endpoints.quality;
	    case 'dev_production':
	    case 'production':
	      return _config.endpoints.production;
	    default:
	      return _config.endpoints.development;
	  }
	}
	
	function changeWebAppUrl(env, name) {
	  var baseUrl = 'https://' + name + '.adparlordev.com';
	  var updatedEnv = (0, _assign2.default)({}, env, { web_app_url: baseUrl });
	  return updatedEnv;
	}
	
	function isProdEnv() {
	  return ("production") === 'production';
	}

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(8), __esModule: true };

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(9);
	module.exports = __webpack_require__(12).Object.assign;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(10);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(25)});

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(11)
	  , core      = __webpack_require__(12)
	  , ctx       = __webpack_require__(13)
	  , hide      = __webpack_require__(15)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , IS_WRAP   = type & $export.W
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE]
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
	    , key, own, out;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function(C){
	      var F = function(a, b, c){
	        if(this instanceof C){
	          switch(arguments.length){
	            case 0: return new C;
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if(IS_PROTO){
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 11 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 12 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(14);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 14 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(16)
	  , createDesc = __webpack_require__(24);
	module.exports = __webpack_require__(20) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(17)
	  , IE8_DOM_DEFINE = __webpack_require__(19)
	  , toPrimitive    = __webpack_require__(23)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(20) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(20) && !__webpack_require__(21)(function(){
	  return Object.defineProperty(__webpack_require__(22)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(21)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 21 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(18)
	  , document = __webpack_require__(11).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(18);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(26)
	  , gOPS     = __webpack_require__(41)
	  , pIE      = __webpack_require__(42)
	  , toObject = __webpack_require__(43)
	  , IObject  = __webpack_require__(30)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(21)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(27)
	  , enumBugKeys = __webpack_require__(40);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(28)
	  , toIObject    = __webpack_require__(29)
	  , arrayIndexOf = __webpack_require__(33)(false)
	  , IE_PROTO     = __webpack_require__(37)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(30)
	  , defined = __webpack_require__(32);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(31);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 31 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 32 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(29)
	  , toLength  = __webpack_require__(34)
	  , toIndex   = __webpack_require__(36);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(35)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(35)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(38)('keys')
	  , uid    = __webpack_require__(39);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(11)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 39 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 40 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 41 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 42 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(32);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(45);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	exports.setDevEnv = setDevEnv;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hierarchy = (0, _stringify2.default)({
	  data: {
	    hierarchy: [{
	      id: 51,
	      name: "Engineering Test Business",
	      description: "AdParlor",
	      created_by: 1,
	      updated_by: 2876,
	      product_type: "managed",
	      status: "ACTIVE_BUSINESS",
	      self_status: "ACTIVE_BUSINESS",
	      generic_status: 1,
	      address1: "129 Spadina Ave.",
	      address2: null,
	      state: null,
	      zip: null,
	      country: null,
	      image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378.png",
	      thumbnail_image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378-200x200.png",
	      twitter_enabled: true,
	      facebook_enabled: true,
	      trivu_enabled: true,
	      dbm_enabled: true,
	      youtube_enabled: true,
	      yahoo_enabled: false,
	      pinterest_enabled: true,
	      snapchat_enabled: true,
	      dcm_enabled: false,
	      advertisers: [{
	        id: 54,
	        name: "Peoples Farm",
	        created_by: null,
	        updated_by: 220,
	        industry_id: 20,
	        status: "ACTIVE_ADVERTISER",
	        inherited_status: "ACTIVE_BUSINESS",
	        self_status: "ACTIVE_ADVERTISER",
	        generic_status: 1,
	        image_path: "/uploaded/images/advertiser_54/c9755ea42775a3da27a4301891c09bc0.jpg",
	        thumbnail_image_path: "/uploaded/images/advertiser_54/c9755ea42775a3da27a4301891c09bc0-200x200.jpg",
	        business_id: 51,
	        agency_id: null,
	        currency_code: "USD",
	        facebook_enabled: true,
	        twitter_enabled: true,
	        trivu_enabled: true,
	        dbm_enabled: true,
	        youtube_enabled: true,
	        yahoo_enabled: false,
	        pinterest_enabled: true,
	        snapchat_enabled: true
	      }, {
	        id: 55,
	        name: "AOL",
	        created_by: 5,
	        updated_by: 2735,
	        industry_id: 20,
	        status: "ACTIVE_ADVERTISER",
	        inherited_status: "ACTIVE_BUSINESS",
	        self_status: "ACTIVE_ADVERTISER",
	        generic_status: 1,
	        image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378.png",
	        thumbnail_image_path: "/uploaded/images/global/a7e512711abf5cc35e6404ed8f260944-200x200.png",
	        business_id: 51,
	        agency_id: null,
	        currency_code: "CAD",
	        facebook_enabled: true,
	        twitter_enabled: true,
	        trivu_enabled: true,
	        dbm_enabled: true,
	        youtube_enabled: true,
	        yahoo_enabled: false,
	        pinterest_enabled: true,
	        snapchat_enabled: true
	      }, {
	        id: 3631,
	        name: "High & Dry Media Inc.",
	        created_by: 6,
	        updated_by: 6,
	        industry_id: 20,
	        status: "ACTIVE_ADVERTISER",
	        inherited_status: "ACTIVE_BUSINESS",
	        self_status: "ACTIVE_ADVERTISER",
	        generic_status: 1,
	        image_path: "/uploaded/images/global/3572b39aeb966d020d4a02d8d5cff378.png",
	        thumbnail_image_path: "/uploaded/images/global/80e0dd4feddda32ec22ec6298e513375-200x200.png",
	        business_id: 51,
	        agency_id: null,
	        currency_code: "USD",
	        facebook_enabled: true,
	        twitter_enabled: true,
	        trivu_enabled: true,
	        dbm_enabled: true,
	        youtube_enabled: true,
	        yahoo_enabled: false,
	        pinterest_enabled: true,
	        snapchat_enabled: true
	      }],
	      sales_region_office_id: 1,
	      support_agencies: true,
	      agencies: [],
	      currency_code: "USD",
	      next_billing_date: null,
	      trial_end_date: null,
	      trial_expired: null
	    }]
	  }
	});
	
	var user = (0, _stringify2.default)({
	  id: 2695,
	  email: "bsheikh@adparlor.com",
	  first_name: "Bill",
	  last_name: "Sheikh",
	  last_sign_in_at: "2017-05-19T15:39:32.000Z",
	  image_path: null,
	  thumbnail_image_path: null,
	  facebook_url: "",
	  linkedin_url: null,
	  skype_id: null,
	  twitter_handle: null,
	  company: "Adparlor",
	  position: "Frontend Developer",
	  is_adparlor: true,
	  is_adparlor_super: false,
	  is_super: false,
	  status: "ACTIVE",
	  phone_number: "911 :)",
	  phone_number_extension: "",
	  roles: ["BUSINESS_51", "ADVERTISER_54", "ADVERTISER_71", "ADVERTISER_75", "ADVERTISER_87", "ADVERTISER_118", "ADVERTISER_3100"],
	  business_ids: [51],
	  has_financial_access: null,
	  preferred_language: "eng",
	  read_only: null,
	  facebook_enabled: true,
	  twitter_enabled: true,
	  trivu_enabled: true,
	  dbm_enabled: true,
	  youtube_enabled: true,
	  yahoo_enabled: false,
	  pinterest_enabled: true,
	  snapchat_enabled: true,
	  created_at: "2016-05-09T18:40:58.000Z",
	  desk_url: "http://support.adparlor.com/customer/authentication/multipass/callback?multipass=W%2F20cTUNQ%2FTTtVul5ideR83NJmsIJNkkuyMYLu3KbGSqqeea04FY5t0y74Tm%0A09pdcbGiyIsYuAQb6RTNC6BT1ZuuSDo9zDznnuxaQNBjZRwNEex915SW%2BfFa%0AKHBN2CWRCId3%2FET9213UcvbVzLlVJIlsrBriqNVbK0yU%2BBoQuAkL8%2FuvfSbC%0AlQKB04HRILo6%0A&signature=c2veQWE5AIS9eVlffREqWPTRuvw%3D%0A"
	});
	
	var ADVERTISERS_AVAIABLE = [54, 55, 3631];
	
	function setDevEnv() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (!options.WSSE) {
	    throw new Error('Error: WSSE token is not provided. Please enter a valid Sandbox or Production WSSE token.');
	  }
	
	  localStorage.setItem("user_language", "eng");
	  localStorage.setItem("System.LocalStorage.Hierarchy", options.hierarchy || hierarchy);
	  localStorage.setItem("User", options.user || user);
	  localStorage.setItem("WSSE", options.WSSE);
	
	  if (!ADVERTISERS_AVAIABLE.includes(parseInt(localStorage.getItem("ADK_ADVERTISER_ID"), 10))) {
	    localStorage.setItem("ADK_ADVERTISER_ID", "" + ADVERTISERS_AVAIABLE[0]);
	  }
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(46), __esModule: true };

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var core  = __webpack_require__(12)
	  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
	module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// webpack_build_csp.js